import { Button, Avatar, Box, Typography, Menu, MenuItem } from '@mui/material';
import { LogIn, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { performCompleteLogout } from '@/lib/auth/logout';

/**
 * サインイン/サインアウトボタン
 * react-oidc-context対応版
 */
export function SignInButton() {
  const { isAuthenticated, isLoading, user, signIn } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    handleMenuClose();
    await performCompleteLogout();
  };

  const handleSignIn = async () => {
    try {
      await signIn();
    } catch (error) {
      console.error('サインインエラー:', error);
    }
  };

  if (isLoading) {
    return (
      <Button color="inherit" disabled>
        読み込み中...
      </Button>
    );
  }

  if (isAuthenticated && user) {
    return (
      <>
        <Box
          onClick={handleMenuOpen}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            gap: 1,
          }}
        >
          <Avatar
            src={user.image || undefined}
            alt={user.name || 'User'}
            sx={{ width: 32, height: 32 }}
          />
          <Typography
            variant="body2"
            sx={{
              color: 'white',
              display: { xs: 'none', sm: 'block' },
            }}
          >
            {user.name || user.email}
          </Typography>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem disabled>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </MenuItem>
          <MenuItem onClick={handleSignOut}>
            <LogOut size={16} style={{ marginRight: 8 }} />
            サインアウト
          </MenuItem>
        </Menu>
      </>
    );
  }

  return (
    <Button color="inherit" onClick={handleSignIn} startIcon={<LogIn size={18} />}>
      サインイン
    </Button>
  );
}
